export default {
  discount_badge: '{{value}} korting',
  high_caffeine_warning_required: 'Hoog cafeïnegehalte',
  pfand: 'Incl. {{value}} statiegeld',
  alcohol_by_volume_percent: '{{value}} % Vol. Alcohol',
};
